import { CiselnaHodnotaSpec } from './ciselna-hodnota-spec';
import { TextovaHodnotaSpec } from './textova-hodnota-spec';
import { UkazovatelRef } from './ukazovatel-ref';

/**
 * 
 * @export
 * @interface MonitorovanyUkazovatelPublicResponse
 */
export interface MonitorovanyUkazovatelPublicResponse {
    /**
     * 
     * @type {string}
     * @memberof MonitorovanyUkazovatelPublicResponse
     */
    'casZneplatnenia'?: string;
    /**
     * 
     * @type {CiselnaHodnotaSpec}
     * @memberof MonitorovanyUkazovatelPublicResponse
     */
    'ciselnaHodnotaSpec'?: CiselnaHodnotaSpec;
    /**
     * 
     * @type {string}
     * @memberof MonitorovanyUkazovatelPublicResponse
     */
    'popis'?: string;
    /**
     * 
     * @type {TextovaHodnotaSpec}
     * @memberof MonitorovanyUkazovatelPublicResponse
     */
    'textovaHodnotaSpec'?: TextovaHodnotaSpec;
    /**
     * 
     * @type {string}
     * @memberof MonitorovanyUkazovatelPublicResponse
     */
    'typ'?: MonitorovanyUkazovatelPublicResponseTypEnum;
    /**
     * 
     * @type {UkazovatelRef}
     * @memberof MonitorovanyUkazovatelPublicResponse
     */
    'ukazovatelRef'?: UkazovatelRef;
    /**
     * 
     * @type {string}
     * @memberof MonitorovanyUkazovatelPublicResponse
     */
    'ukazovatelVyzvyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitorovanyUkazovatelPublicResponse
     */
    'validateTyp'?: MonitorovanyUkazovatelPublicResponseValidateTypEnum;
}

export const MonitorovanyUkazovatelPublicResponseTypEnum = {
    Kvantitativny: 'KVANTITATIVNY',
    Kvalitativny: 'KVALITATIVNY'
} as const;

export type MonitorovanyUkazovatelPublicResponseTypEnum = typeof MonitorovanyUkazovatelPublicResponseTypEnum[keyof typeof MonitorovanyUkazovatelPublicResponseTypEnum];
export const MonitorovanyUkazovatelPublicResponseValidateTypEnum = {
    LogickaHodnota: 'LOGICKA_HODNOTA',
    ZoznamHodnota: 'ZOZNAM_HODNOTA',
    TextovaHodnota: 'TEXTOVA_HODNOTA',
    CiselnaHodnota: 'CISELNA_HODNOTA'
} as const;

export type MonitorovanyUkazovatelPublicResponseValidateTypEnum = typeof MonitorovanyUkazovatelPublicResponseValidateTypEnum[keyof typeof MonitorovanyUkazovatelPublicResponseValidateTypEnum];


